__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "@adsk/bim360-navisworks-issues-ui";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("react-dom", "17.0.2", () => (Promise.all([__webpack_require__.e(385), __webpack_require__.e(331), __webpack_require__.e(225), __webpack_require__.e(887), __webpack_require__.e(198), __webpack_require__.e(239), __webpack_require__.e(868), __webpack_require__.e(402), __webpack_require__.e(627), __webpack_require__.e(504), __webpack_require__.e(845), __webpack_require__.e(952), __webpack_require__.e(618), __webpack_require__.e(944), __webpack_require__.e(764), __webpack_require__.e(614), __webpack_require__.e(423), __webpack_require__.e(540)]).then(() => (() => (__webpack_require__(241752))))));
			register("react", "17.0.2", () => (Promise.all([__webpack_require__.e(385), __webpack_require__.e(331), __webpack_require__.e(225), __webpack_require__.e(887), __webpack_require__.e(198), __webpack_require__.e(239), __webpack_require__.e(868), __webpack_require__.e(402), __webpack_require__.e(627), __webpack_require__.e(504), __webpack_require__.e(845), __webpack_require__.e(952), __webpack_require__.e(618), __webpack_require__.e(944), __webpack_require__.e(764), __webpack_require__.e(614), __webpack_require__.e(423)]).then(() => (() => (__webpack_require__(287561))))));
			register("styled-components", "5.3.11", () => (Promise.all([__webpack_require__.e(385), __webpack_require__.e(331), __webpack_require__.e(225), __webpack_require__.e(887), __webpack_require__.e(198), __webpack_require__.e(239), __webpack_require__.e(868), __webpack_require__.e(402), __webpack_require__.e(627), __webpack_require__.e(504), __webpack_require__.e(845), __webpack_require__.e(952), __webpack_require__.e(618), __webpack_require__.e(944), __webpack_require__.e(764), __webpack_require__.e(614), __webpack_require__.e(423), __webpack_require__.e(540)]).then(() => (() => (__webpack_require__(979859))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};